import $ from 'jquery';
import skipLinks from './utils/skipLinks';
import iframer from './utils/iframer';
import closeNotification from './utils/closeNotification';
import mNav from './utils/mNav';
import searchExpand from './utils/searchExpand';
import setupSharing from './utils/social';
import equalHeight from './utils/equalHeight';
import googleMaps from './utils/googleMaps';
import twitterFeed from './utils/twitterFeed';
// import setupDrawers from './utils/setupDrawers';
import setupTabs from './utils/setupTabs';
import setupTagsReveal from './utils/setupTagsReveal';
import listShowHide from './utils/listShowHide';
import filterTable from './utils/filterTable';
import sortTable from './utils/sortTable';
import multiNav from './utils/multiNav';
import shareURL from './utils/shareURL';

function globals () {

    // iframe video in body content
    iframer();

    // Small Screen Navigation
    mNav(
        '#navigation-toggle',
        'navigation-toggle--open',
        '#navigation-primary__items',
        'navigation-primary__items--open'
    );

    // Multi Navigation
    multiNav(
        '#navigation-primary',
    );

    // Filter open close
    mNav(
        '.filter-trigger',
        'filter-trigger--open',
        '#js-filter',
        'js-filter--open'
    );

    // inpage showHide
    mNav(
        '#navigation-inpage-trigger',
        'navigation-inpage__trigger--open',
        '#navigation-inpage-items',
        'navigation-inpage__items--open'
    );

    // Search expand
    searchExpand(
        '#js-search-expand',
        '.header-search',
        'header-search--open'
    );

    // social
    setupSharing();

    // Equal height
    // Enter class of parent
    // equalHeight('');

    // google maps
    googleMaps();

    // twitters
    twitterFeed();

    listShowHide();

    // setupDrawers();

    setupTabs();

    setupTagsReveal();

    filterTable();
    sortTable();

    shareURL('.shareURL');

};


$(function run () {
    console.log('ᕕ( ᐛ )ᕗ Running...');
    globals();
});